'use client';

import { ReactNode, useRef } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'motion/react';

type Props = {
  children: ReactNode;
  intensity?: number;
};

export default function ParallaxImage({ children, intensity = 60 }: Props) {
  const ref = useRef<HTMLElement>(null);
  const reduced = useReducedMotion();

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });

  const y = useTransform(scrollYProgress, [0, 1], [-intensity, intensity]);

  if (reduced) {
    return <>{children}</>;
  }

  return (
    <motion.article ref={ref} style={{ y, willChange: 'transform', width: '100%', height: '100%' }}>
      {children}
    </motion.article>
  );
}
